<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <h2 v-if="!isVerified && (isKyc || isKyb)" :class="b('title')">КУС/КУВ</h2>

    <div :class="b('wrapper')">
      <SharedVerificationStatus
        v-if="!isVerified && !isKyc && !isKyb"
        variant="warning"
        title="Верификация не пройдена"
        description="Пока аккаунт не верифицирован, пополнение, вывод и обмен недоступны. Подготовьте паспорт (для компании — регистрационные документы) — заполнение занимает около 10 минут, проверка обычно до 24 часов."
        :tags="[
          'Пополнение недоступно',
          'Вывод недоступен',
          'Обмен недоступен',
        ]"
        action-label="Пройти верификацию"
        @action="handleVerification"
      />

      <SharedVerificationStatus
        v-if="isVerified"
        variant="success"
        title="Верификация подтверждена"
        description="Аккаунт успешно верифицирован. Вам доступны пополнение, вывод средств и обмен."
        :tags="['Пополнение доступно', 'Вывод доступен', 'Обмен доступен']"
      />

      <div v-if="!isVerified && isKyc" :class="b('block')">
        <div :class="b('group')">
          <h4 :class="b('group-title')">
            {{ $t("Паспорт или ВУ") }}
          </h4>

          <div :class="b('fields', { passport: true })">
            <SharedUpload
              :document="kycDocuments['kyc-personal-documents-passport-selfie']"
              :is-readonly="true"
              :is-download="true"
              :is-loading="isLoading"
            >
              <template #label
                >{{ $t("Страница") }} <br />{{ $t("с фото") }}</template
              >
            </SharedUpload>

            <SharedUpload
              :document="
                kycDocuments['kyc-personal-documents-passport-organization']
              "
              :is-readonly="true"
              :is-download="true"
              :is-loading="isLoading"
            >
              <template #label
                >{{ $t("Страница") }} <br />{{ $t("кем выдан") }}</template
              >
            </SharedUpload>

            <SharedUpload
              :document="
                kycDocuments['kyc-personal-documents-passport-address']
              "
              :is-readonly="true"
              :is-download="true"
              :is-loading="isLoading"
            >
              <template #label
                >{{ $t("Страница") }} <br />{{ $t("с пропиской") }}</template
              >
            </SharedUpload>
          </div>
        </div>

        <div :class="b('group')">
          <h4 :class="b('group-title')">{{ $t("Селфи") }}</h4>

          <div :class="b('fields', { selfie: true })">
            <SharedUpload
              :document="kycDocuments['kyc-personal-documents-selfie']"
              :is-readonly="true"
              :isCenter="true"
              :is-label="false"
              :is-download="true"
              :is-loading="isLoading"
            />
          </div>
        </div>
      </div>

      <div v-if="!isVerified && isKyb" :class="b('group')">
        <h4 :class="b('group-title')">{{ $t("Соглашения") }}</h4>

        <div :class="b('fields', { agreements: true })">
          <SharedUpload
            :class="b('upload')"
            :document="kybDocuments['kyb-documents-document']"
            :is-readonly="true"
            :is-download="true"
            :is-loading="isLoading"
          >
            <template #label
              >{{ $t("Анкета") }} <br />{{ $t("юридического лица") }}</template
            >
          </SharedUpload>

          <SharedUpload
            :class="b('upload')"
            :document="kybDocuments['kyb-documents-beneficiary']"
            :is-readonly="true"
            :is-download="true"
            :is-loading="isLoading"
          >
            <template #label>
              {{ $t("Анкета") }} <br />{{ $t("бенефициарного") }} <br />{{
                $t("владельца")
              }}
            </template>
          </SharedUpload>

          <SharedUpload
            :class="b('upload')"
            :document="kybDocuments['kyb-documents-broker']"
            :is-readonly="true"
            :is-download="true"
            :is-loading="isLoading"
          >
            <template #label
              >{{ $t("Брокерский") }} <br />{{ $t("договор") }}</template
            >
          </SharedUpload>

          <SharedUpload
            :class="b('upload')"
            :document="kybDocuments['kyb-documents-declaration']"
            :is-readonly="true"
            :is-download="true"
            :is-loading="isLoading"
          >
            <template #label
              >{{ $t("Декларация") }} <br />{{ $t("о рисках") }}</template
            >
          </SharedUpload>
        </div>
      </div>
    </div>
  </div>
</template>
